import { render, staticRenderFns } from "./OrderCell.vue?vue&type=template&id=5ac6b8ad&scoped=true"
import script from "./OrderCell.vue?vue&type=script&lang=js"
export * from "./OrderCell.vue?vue&type=script&lang=js"
import style0 from "./OrderCell.vue?vue&type=style&index=0&id=5ac6b8ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6b8ad",
  null
  
)

export default component.exports